<template>
	<div class="share-link-dialog-wrap">
		<el-dialog
			title="我的分享链接"
			:visible.sync="dialogVisible"
			width="420px"
			:close-on-click-modal="true"
			@close="handleClose"
		>
			<div class="share-dialog-content" v-loading="loading">
				<div class="qrcode-section" v-if="shareUrl">
					<div class="qrcode-wrapper">
						<vue-qr :text="shareUrl" :size="220" :margin="10"></vue-qr>
					</div>
				</div>
				<div class="link-section" v-if="shareUrl">
					<p class="link-label">分享链接：</p>
					<div class="link-input-wrapper">
						<el-input :value="shareUrl" readonly size="small"></el-input>
						<el-button type="primary" size="small" @click="handleCopyLink">复制</el-button>
					</div>
				</div>
				<div class="invite-code-section" v-if="userInfo.invite_code">
					<p class="link-label">我的邀请码：</p>
					<div class="link-input-wrapper">
						<el-input :value="userInfo.invite_code" readonly size="small"></el-input>
						<el-button type="primary" size="small" @click="handleCopyInviteCode">复制</el-button>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { getAppShareXcode, getAppShareInfo } from '@/api/public'
import vueQr from 'vue-qr'

export default {
	name: 'ShareLinkDialog',
	components: {
		vueQr
	},
	data() {
		return {
			dialogVisible: false,
			loading: false,
			shareUrl: ''
		}
	},
	computed: {
		userInfo() {
			return this.$store.getters.info || {}
		}
	},
	methods: {
		// 方式一：传入 userId，通过接口获取分享链接
		open(url) {
            var self = this
			this.dialogVisible = true
			this.shareUrl = url
			
		},

		// 方式二：直接传入已有的 shareUrl，跳过接口请求
		openWithUrl(url) {
			this.dialogVisible = true
			this.shareUrl = url || ''
			this.loading = false
		},

		// 复制链接
		handleCopyLink() {
			var self = this
			this.$copyText(this.shareUrl).then(function() {
				self.$message.success('复制成功')
			}, function() {
				self.$message.error('复制失败，请手动复制')
			})
		},

		// 复制邀请码
		handleCopyInviteCode() {
			var self = this
			this.$copyText(String(this.userInfo.invite_code)).then(function() {
				self.$message.success('复制成功')
			}, function() {
				self.$message.error('复制失败，请手动复制')
			})
		},

		// 关闭弹窗
		handleClose() {
			this.dialogVisible = false
		}
	}
}
</script>

<style lang="scss">
.share-dialog-content {
	padding: 10px 0;
	min-height: 100px;

	.qrcode-section {
		text-align: center;
		margin-bottom: 20px;

		.qrcode-wrapper {
			display: inline-block;
			padding: 12px;
			border: 1px solid #ebeef5;
			border-radius: 8px;

			canvas, img {
				display: block;
			}
		}

		.qrcode-tip {
			margin-top: 10px;
			font-size: 13px;
			color: #909399;
		}
	}

	.link-section {
		.link-label {
			margin-bottom: 8px;
			font-size: 14px;
			color: #606266;
			font-weight: 500;
		}

		.link-input-wrapper {
			display: flex;
			gap: 8px;

			.el-input {
				flex: 1;
			}
		}
	}

	.invite-code-section {
		margin-top: 20px;

		.link-label {
			margin-bottom: 8px;
			font-size: 14px;
			color: #606266;
			font-weight: 500;
		}

		.link-input-wrapper {
			display: flex;
			gap: 8px;

			.el-input {
				flex: 1;
			}
		}
	}

	.empty-tip {
		text-align: center;
		padding: 40px 0;
		color: #909399;
		font-size: 14px;

		i {
			font-size: 24px;
			margin-right: 6px;
			vertical-align: middle;
		}
	}
}
</style>
